import React from "react";
import { Link as RouterLink } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { SvgIcon } from "@mui/material";

const Header = () => {
  return (
    <AppBar position="static" className="bg-gray-800">
      <Toolbar>
        <SvgIcon className="mr-2" viewBox="0 0 24 24">
          <path
            d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c1.1 0 2-.9 2-2 0-.5-.2-1-.5-1.3-.3-.4-.5-.8-.5-1.3 0-1.1.9-2 2-2h2.4c3 0 5.6-2.5 5.6-5.6C22 5.8 17.7 2 12 2z"
            fill="#e2e8f0"
          />
          <circle cx="7" cy="10" r="1.8" fill="#f87171" />
          <circle cx="10" cy="6.5" r="1.8" fill="#fbbf24" />
          <circle cx="14" cy="6.5" r="1.8" fill="#34d399" />
          <circle cx="17" cy="10" r="1.8" fill="#818cf8" />
        </SvgIcon>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <RouterLink to="/" className="text-white no-underline">
            MemeGen
          </RouterLink>
        </Typography>
        <Button color="inherit" component={RouterLink} to="/">
          Library
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
